import React, { useState } from 'react';
import { useTranslation } from '../contexts/TranslationContext';
import { validateName, validateEmail } from '../utils/formValidation';
import { LANGUAGES } from '../utils/languages';
import { COUNTRIES } from '../utils/countries';

/**
 * UserInfoForm component
 * Handles user information input: name, email, video language, and country
 */
function UserInfoForm({
  userName,
  setUserName,
  userEmail,
  setUserEmail,
  videoLanguage,
  setVideoLanguage,
  videoCountry,
  setVideoCountry,
}) {
  const { t } = useTranslation();
  const [nameError, setNameError] = useState('');
  const [emailError, setEmailError] = useState('');

  const handleNameChange = (e) => {
    const value = e.target.value;
    setUserName(value);
    
    // Validate on change
    const validation = validateName(value);
    // Translate error message
    if (validation.error) {
      const errorKey = validation.error.toLowerCase().includes('required') ? 'nameRequired' :
                      validation.error.toLowerCase().includes('at least') ? 'nameMinLength' :
                      validation.error.toLowerCase().includes('less than') ? 'nameMaxLength' :
                      validation.error.toLowerCase().includes('only contain') ? 'nameInvalidChars' : 'nameRequired';
      setNameError(t(errorKey));
    } else {
      setNameError('');
    }
  };

  const handleNameBlur = () => {
    // Validate on blur
    const validation = validateName(userName);
    if (validation.error) {
      const errorKey = validation.error.toLowerCase().includes('required') ? 'nameRequired' :
                      validation.error.toLowerCase().includes('at least') ? 'nameMinLength' :
                      validation.error.toLowerCase().includes('less than') ? 'nameMaxLength' :
                      validation.error.toLowerCase().includes('only contain') ? 'nameInvalidChars' : 'nameRequired';
      setNameError(t(errorKey));
    } else {
      setNameError('');
    }
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setUserEmail(value);
    
    // Validate on change
    const validation = validateEmail(value);
    if (validation.error) {
      const errorKey = validation.error.toLowerCase().includes('required') ? 'emailRequired' :
                      validation.error.toLowerCase().includes('valid') ? 'emailInvalid' :
                      validation.error.toLowerCase().includes('too long') ? 'emailTooLong' : 'emailRequired';
      setEmailError(t(errorKey));
    } else {
      setEmailError('');
    }
  };

  const handleEmailBlur = () => {
    // Validate on blur
    const validation = validateEmail(userEmail);
    if (validation.error) {
      const errorKey = validation.error.toLowerCase().includes('required') ? 'emailRequired' :
                      validation.error.toLowerCase().includes('valid') ? 'emailInvalid' :
                      validation.error.toLowerCase().includes('too long') ? 'emailTooLong' : 'emailRequired';
      setEmailError(t(errorKey));
    } else {
      setEmailError('');
    }
  };

  return (
    <div className="user-info-form">
      <div className="form-group">
        <label htmlFor="user-name">
          {t('yourName')} <span className="required">{t('required')}</span>
        </label>
        <input
          id="user-name"
          type="text"
          value={userName}
          onChange={handleNameChange}
          onBlur={handleNameBlur}
          className={nameError ? 'input-error' : ''}
          placeholder={t('enterFullName')}
          required
        />
        {nameError && <span className="error-message">{nameError}</span>}
      </div>

      <div className="form-group">
        <label htmlFor="user-email">
          {t('yourEmail')} <span className="required">{t('required')}</span>
        </label>
        <input
          id="user-email"
          type="email"
          value={userEmail}
          onChange={handleEmailChange}
          onBlur={handleEmailBlur}
          className={emailError ? 'input-error' : ''}
          placeholder={t('enterEmail')}
          required
        />
        {emailError && <span className="error-message">{emailError}</span>}
      </div>

      <div className="form-group">
        <label htmlFor="video-language">{t('videoLanguage')}</label>
        <select
          id="video-language"
          value={videoLanguage}
          onChange={(e) => setVideoLanguage(e.target.value)}
        >
          <option value="">{t('selectLanguageOption')}</option>
          {LANGUAGES.map(lang => (
            <option key={lang.code} value={lang.code}>
              {lang.name}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label htmlFor="video-country">{t('countryRecorded')}</label>
        <select
          id="video-country"
          value={videoCountry}
          onChange={(e) => setVideoCountry(e.target.value)}
        >
          <option value="">{t('selectCountryOption')}</option>
          {COUNTRIES.map(country => (
            <option key={country.code} value={country.code}>
              {country.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

export default UserInfoForm;

